module.exports = __webpack_public_path__ + "static/img/reject.aa08ee72.png";